import { useEffect, useState } from "react";
import { getToken } from "../api/http";
import { mailEventsURL } from "../api/mailTracking";

export type AdBlockDurum = "bilinmiyor" | "temiz" | "engelli";

// useAdBlock — reklam engelleyicinin paneli kırıp kırmadığını anlar.
//
// ÜÇ bağımsız sinyal; biri bile yeterlidir. Tek sinyale güvenmek yetmedi:
// ilk sürüm yalnız fetch testi yapıyordu ve engelleyici o isteği geçirip
// SSE akışını kestiği için uyarı hiç çıkmadı (kullanıcı bildirdi). Filtre
// listeleri isteği YOLA göre olduğu kadar TÜRÜNE göre de eler; bu yüzden
// hem fetch hem EventSource denenir.
//
//  1. FETCH TESTİ — yolunda "tracking" geçen bir uca istek. Ağ hatasıyla
//     reddedilirse istek kesilmiştir. Sunucudan herhangi bir yanıt gelmesi
//     (200/401/404) "engel yok" demektir; içerik değil, ULAŞMASI önemli.
//
//  2. SSE TESTİ — asıl kırılan yüzey. Kısa ömürlü bir EventSource açılır;
//     3 saniye içinde bağlantı kurulmazsa (onopen gelmezse) engellenmiş
//     sayılır. Panelin canlı güncellemesi tam olarak bu yolu kullanıyor.
//
//  3. KOZMETİK TEST — bazı engelleyiciler isteği kesmek yerine öğeyi CSS
//     ile gizler; reklam gibi görünen bir yem öğesinin yüksekliği sıfırsa
//     eklenti çalışıyor demektir.
//
// Yanlış pozitif riski: internet tamamen kopuksa 1 ve 2 de başarısız olur.
// Bu yüzden uyarı panelin çalışmasını engellemez, yalnız bilgilendirir.
export function useAdBlock(): AdBlockDurum {
  const [durum, setDurum] = useState<AdBlockDurum>("bilinmiyor");

  useEffect(() => {
    let iptal = false;

    async function fetchTesti(): Promise<boolean> {
      try {
        const t = getToken();
        await fetch("/api/v1/admin/mail/tracking/ping", {
          method: "GET",
          headers: t ? { Authorization: `Bearer ${t}` } : undefined,
          cache: "no-store",
        });
        return false;
      } catch {
        return true;
      }
    }

    function sseTesti(): Promise<boolean> {
      return new Promise((coz) => {
        let es: EventSource | null = null;
        try {
          es = new EventSource(mailEventsURL());
        } catch {
          coz(true);
          return;
        }
        const bitir = (engelli: boolean) => {
          window.clearTimeout(zaman);
          es?.close();
          coz(engelli);
        };
        // Bağlantı kurulduysa engel yok; hata gelirse ya da 3 sn'de hiçbir
        // şey olmazsa engellenmiş say.
        es.onopen = () => bitir(false);
        es.onerror = () => bitir(true);
        const zaman = window.setTimeout(() => bitir(true), 3000);
      });
    }

    function kozmetikTest(): boolean {
      const yem = document.createElement("div");
      yem.className = "adsbox ad-placement pub_300x250 banner_ad";
      yem.style.cssText = "position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;";
      document.body.appendChild(yem);
      const gizli = yem.offsetHeight === 0;
      yem.remove();
      return gizli;
    }

    (async () => {
      const [ag, sse] = await Promise.all([fetchTesti(), sseTesti()]);
      if (iptal) return;
      setDurum(ag || sse || kozmetikTest() ? "engelli" : "temiz");
    })();

    return () => { iptal = true; };
  }, []);

  return durum;
}
